import { useDropzone } from "react-dropzone";
import DropzoneOverlay from "./DropzoneOverlay";
import { BsImageAlt } from "react-icons/bs";
import PropTypes from "prop-types";

const CustomDropzone = ({ options, label, className, icon }) => {
  const { getRootProps, getInputProps, isDragActive, isDragReject } =
    useDropzone({ ...options });
  return (
    <div
      {...getRootProps({
        className,
      })}
    >
      <input {...getInputProps()} />
      <div>{icon || <BsImageAlt className="fs-1 my-4" />}</div>
      <p className="fs-5 text-gray fw-light pt-3 pb-1">{label}</p>

      <DropzoneOverlay
        isDragActive={isDragActive}
        isDragReject={isDragReject}
        isMultiple={options?.multiple}
      />
    </div>
  );
};

CustomDropzone.propTypes = {
  options: PropTypes.shape({
    accept: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
      PropTypes.string,
    ]),
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    onDrop: PropTypes.func.isRequired,
  }).isRequired,
};

export default CustomDropzone;
